import React from 'react';
import { Link } from 'react-router';

import './style.css';

const BackLink = props => {
  return (
    <nav aria-label="back" role="navigation">
      <ol className="breadcrumb pt-3 mb-0">
        <li className="breadcrumb-item" aria-current="page">
          <Link to={props.href}>
            <i className="fa fa-chevron-left mr-1" />{' '}
            <span className="breadcrumb-text"> {props.text} </span>
          </Link>
        </li>
      </ol>
    </nav>
  );
};

export default BackLink;



// WEBPACK FOOTER //
// ./src/pages/student/ReportIssue/BackLink/index.js